export const ADD_TO_BASKET = "ADD_TO_BASKET";
export const REMOVE_FROM_BASKET = "REMOVE_FROM_BASKET";
export const SET_USER = "SET_USER";
export const EMPTY_BASKET = "EMPTY_BASKET";

// firebase deploy --only hosting:clone-513f7
